import React from "react";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import colors from "../../../constants/colors";
import { UserManagementPowRoleResponse } from "../../../models/Administration";
import { camelToTitleCase } from "../../../utils";
import { Typography, Checkbox } from "@material-ui/core";

interface UserProductDisplayCardProps {
	//Product Role to display the name for and allow to be added to user.
	productRole: UserManagementPowRoleResponse;
	//Indicates whether the productRole is selected.
	selected: boolean;
	//Indicates whether the productRole is enabled for the current user.
	enabled: boolean;
	//Indicates whether the productRole has been edited this session.
	edited: boolean;
	//This method passes back the Id of the product role to be added or deleted for the user.
	editRoles: (productRoleId: string) => void;
	//This method passes back the Id of the product role to be set to selected.
	setSelectedProductRole: (productRoleId: string) => void;
}

const useStyles = makeStyles((theme) => ({
	card: {
		borderRadius: theme.spacing(0.5),
		width: "100%",
	},
	cardContent: {
		padding: theme.spacing(1),
		display: "flex",
		justifyContent: "space-between",
	},
}));

/**
 * Takes in a productRole and displays the name and allows it to be selected
 * to be either added or removed from ausers permissions.
 * @param props
 */
export const UserProductRoleDisplayCard = (props: UserProductDisplayCardProps) => {
	const classes = useStyles();

	return (
		<Card
			className={classes.card}
			style={{ backgroundColor: props.selected ? colors.gray300 : colors.white }}
			onClick={() => props.setSelectedProductRole(props.productRole.productXPowRoleId)}
		>
			<div className={classes.cardContent}>
				<span>
					<Typography
						style={{
							display: "flex",
							fontWeight: props.enabled ? "bold" : "normal",
							fontStyle: props.edited ? "italic" : "normal",
							justifyContent: "space-between",
							alignItems: "center",
							marginBottom: 6,
						}}
					>
						{camelToTitleCase(props.productRole.roleName)}
					</Typography>
				</span>
				<span>
					<Checkbox
						checked={props.enabled}
						onChange={() => props.editRoles(props.productRole.productXPowRoleId)}
						inputProps={{
							"aria-label": "primary checkbox",
						}}
					/>
				</span>
			</div>
		</Card>
	);
};
